import React from 'react';

const Rules = () => {
  const rules = [
    {
      category: 'General Rules',
      items: [
        'All players must be registered members of KNKSS',
        'Players must wear proper cricket attire during matches',
        'Respect the decisions of umpires and match officials',
        'Maintain sportsmanship and fair play at all times'
      ]
    },
    {
      category: 'Match Rules',
      items: [
        'Matches will be played according to ICC regulations',
        'Teams must arrive 30 minutes before scheduled match time',
        'Each team must provide one umpire for matches',
        'Match fixtures cannot be changed without committee approval'
      ]
    },
    {
      category: 'Practice Sessions',
      items: [
        'Practice sessions are scheduled on weekdays from 4 PM to 7 PM',
        'Members must book nets in advance',
        'Proper cricket equipment must be used during practice',
        'Follow safety guidelines during practice sessions'
      ]
    },
    {
      category: 'Membership',
      items: [
        'Annual membership fees must be paid on time',
        'Members must attend at least 60% of practice sessions',
        'Maintain proper conduct and discipline',
        'Follow club guidelines and regulations'
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">Rules & Regulations</h1>
          <p className="text-lg text-gray-600">Guidelines for all KNKSS members</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {rules.map((section, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
            >
              <div className="p-6">
                <h2 className="text-xl font-bold text-gray-900 mb-4">{section.category}</h2>
                <ul className="space-y-3">
                  {section.items.map((rule, ruleIndex) => (
                    <li key={ruleIndex} className="flex items-start">
                      <div className="flex-shrink-0 h-6 w-6 rounded-full bg-blue-100 flex items-center justify-center mt-0.5">
                        <span className="text-blue-600 text-sm font-semibold">{ruleIndex + 1}</span>
                      </div>
                      <span className="ml-3 text-gray-600">{rule}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-white rounded-lg shadow-lg p-6 sm:p-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4">Important Notes</h2>
          <div className="prose prose-blue max-w-none">
            <ul className="space-y-2 text-gray-600">
              <li>Rules are subject to change with committee approval</li>
              <li>Members will be notified of any changes via email</li>
              <li>Violation of rules may result in disciplinary action</li>
              <li>For any clarification, contact the club secretary</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Rules; 